import api from "@/lib/axios";

export const getProducts = async () => {
  const { data } = await api.get("/products");
  return data.data;
};

export const createProduct = async (payload) => {
  const { data } = await api.post("/products", payload);
  return data.data;
};

export const updateProduct = async (id, payload) => {
  const { data } = await api.patch(`/products/${id}`, payload);
  return data.data;
};

export const deleteProduct = async (id) => {
  const { data } = await api.delete(`/products/${id}`);
  return data.data;
};

export const updateProductRank = async (ranks) => {
  const { data } = await api.patch("/products/rank", { ranks });
  return data.data;
};

export const bulkAdjustPrices = async (payload) => {
  const { data } = await api.post("/products/bulk-adjust", payload);
  return data.data;
};

export const updateProductBulkPrice = async (items) => {
  const { data } = await api.patch("/products/bulk-price", { items });
  return data.data;
};

// Push this product's integration price to every active connection (all branches).
export const pushProductPrice = async (id) => {
  const { data } = await api.post(`/products/${id}/push`);
  return data.data;
};

export const uploadProductImage = async (id, formData) => {
  const { data } = await api.patch(`/products/${id}/image`, formData);
  return data.data;
};

export const removeProductImage = async (id) => {
  const { data } = await api.delete(`/products/${id}/image`);
  return data.data;
};
